// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#ranking-board{width:20%;box-shadow:0 0 3px #00f;display:flex;flex-direction:column;background-color:rgba(6,30,93,.5);border-top:2px solid rgba(1,153,209,.5);box-sizing:border-box;padding:0 30px}#ranking-board .ranking-board-title{font-weight:700;height:50px;display:flex;align-items:center;font-size:20px}#ranking-board .dv-scroll-ranking-board{flex:1}", ""]);
// Exports
module.exports = exports;
